module.exports = __webpack_public_path__ + "img/eason-pro.964ab8c7.jpg";